var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.isPc
    ? _c(
        "div",
        { staticClass: "top-header" },
        [
          _c("img", {
            staticClass: "logo",
            attrs: { src: require("../../../assets/logo.png") }
          }),
          _vm._v(" "),
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: {
                "default-active": _vm.$store.state.menuActive,
                mode: "horizontal",
                "background-color": "#15185f",
                "text-color": "#fff",
                "active-text-color": "#fff"
              },
              on: { select: _vm.handleSelect }
            },
            [
              _c("el-menu-item", { attrs: { index: "home" } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-menu-item", { attrs: { index: "product" } }, [
                _vm._v("产品")
              ]),
              _vm._v(" "),
              _c("el-menu-item", { attrs: { index: "solution" } }, [
                _vm._v("解决方案")
              ]),
              _vm._v(" "),
              _c("el-menu-item", { attrs: { index: "contact" } }, [
                _vm._v("联系我们")
              ])
            ],
            1
          )
        ],
        1
      )
    : _c("div", { staticClass: "top-header" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("../../../assets/logo.png") }
        })
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6bfc984a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6bfc984a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/header/index.vue
// module id = 8j5Q
// module chunks = 8